import { CloseCircleFilled, SearchOutlined } from "@ant-design/icons"
import { useDebounceFn } from "ahooks"
import { Input, type InputProps } from "components/Input/Input"
import { useEffect, useState } from "react"
import { cn } from "styles/cn"
import { compareValues } from "utils"
import { DEBOUNCE_TIME } from "utils/constants"

export function SearchInput({
	value,
	className,
	onSearch,
	...props
}: InputProps & {
	onSearch: (query: string) => void
}) {
	const [inputValue, setInputValue] = useState(value ?? "")

	useEffect(() => {
		setInputValue(value ?? "")
	}, [value])

	const debouncedSearch = useDebounceFn(
		(newValue: string) => {
			onSearch(newValue)
		},
		{ wait: DEBOUNCE_TIME },
	)
	const searchHandler = (newValue: string) => {
		setInputValue(newValue)
		if (compareValues(newValue, (value as string) ?? "")) {
			return
		}
		debouncedSearch.run(newValue)
	}

	return (
		<Input
			{...props}
			value={inputValue}
			aria-label={props["aria-label"] ?? props.placeholder ?? "Search"}
			autoFocus
			allowClear={ALLOW_CLEAR}
			prefix={<SearchOutlined aria-hidden />}
			className={cn("w-full", className)}
			onChange={(e) => searchHandler(e.target.value)}
		/>
	)
}

const ALLOW_CLEAR = {
	clearIcon: <CloseCircleFilled aria-label="Clear search" />,
}
